<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'ruleVaccination', params: {} }">
            Rule Vaccination
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'ruleVaccinationView', params: {} }">
              View Rule Vaccination
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Rule Vaccination
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="ruleVaccination.multipleDose">
            <td max-width="35%" class="text-subtitle-1">Multiple Doses:</td>
            <td>{{ ruleVaccination.multipleDose }}</td>
          </tr>
          
          <tr v-if="ruleVaccination.annually">
            <td max-width="35%" class="text-subtitle-1">Annually:</td>
            <td>{{ ruleVaccination.annually }}</td>
          </tr>
          
          <tr v-if="ruleVaccination.minAge">
            <td max-width="35%" class="text-subtitle-1">Start Age:</td>
            <td>{{ ruleVaccination.minAge }}</td>
          </tr>
          
          <tr v-if="ruleVaccination.doseCount">
            <td max-width="35%" class="text-subtitle-1">Dose Count:</td>
            <td>{{ ruleVaccination.doseCount }}</td>
          </tr>
          
          <tr v-if="ruleVaccination.timeBetweenDose">
            <td max-width="35%" class="text-subtitle-1">Time between Doses:</td>
            <td>{{ ruleVaccination.timeBetweenDose }}</td>
          </tr>
          
          <tr v-if="ruleVaccination.timeBetweenDoseUnit">
            <td max-width="35%" class="text-subtitle-1">Time between Doses:</td>
            <td>{{ ruleVaccination.timeBetweenDoseUnit }}</td>
          </tr>
          
          <tr v-if="ruleVaccination.requirement">
            <td max-width="35%" class="text-subtitle-1">Requirement:</td>
            <td>
              {{ getRelationText(ruleVaccination.requirement, "requirement", "name") }}
            </td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getRuleVaccination } from "@/services/ruleVaccination";
    
              import { getAllRequirements } from "@/services/requirement";
            

    export default {
      data() {
        return {
            id: '',
            ruleVaccination: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "ruleVaccinationEdit", params: { id: id }});
        },
        setInstance() {
          this.setDependencies().then( () => {
            getRuleVaccination(this.id)
            .then((response) => {
              this.ruleVaccination = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading ruleVaccination");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          
            const params_requirement = {
              page: 0,
              size: 100
            };
            await getAllRequirements(params_requirement)
              .then(response => {
                this.relations.requirement = response.data.content;
                return this.relations.requirement;
              });
            
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstance();
        this.$emit("showParent", false);
      }
    }
    </script>
    